module.exports = __webpack_public_path__ + "img/marker_two_red2.ff660790.png";